import { graphql, useStaticQuery } from 'gatsby';

export default function useSiteMetadata() {
  const {
    site: { siteMetadata },
  } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          twitterUsername
          image
          siteUrl
        }
      }
    }
  `);

  return siteMetadata;
}
